<ol class="breadcrumb page-breadcrumb">
    <li class="breadcrumb-item">
        <a href="javascript:void(0);" [routerLink]="['/admin/home']">Home</a>
    </li>
    <li class="breadcrumb-item">
        <a href="javascript:void(0);" [routerLink]="['/admin/packagelist']">Pacotes</a>
    </li>
    <li class="breadcrumb-item active">Novo pacote</li>
    <li class="position-absolute pos-top pos-right d-none d-sm-block"><span class="js-get-date"></span></li>
</ol>
<div id="panel-2" class="panel">
    <div class="panel-hdr bg-primary-600 bg-primary-gradient">
        <h2>
            Novo <span class="fw-300"><i>Pacote</i></span>
        </h2>
        <div class="panel-toolbar">
            <a href="javascript:void(0);" class="btn btn-success btn-sm btn-icon rounded-circle waves-effect waves-themed mr-2"
                data-action="panel-collapse" data-toggle="tooltip" data-offset="0,10" data-original-title="Collapse">
                <i class="fal fa-minus text-white fw-900"></i>
            </a>
            <a href="javascript:void(0);" class="btn btn-warning btn-sm btn-icon rounded-circle waves-effect waves-themed mr-2"
                data-action="panel-collapse" data-toggle="tooltip" data-offset="0,10" data-original-title="Fullscreen">
                <i class="fal fa-expand text-primary fw-900"></i>
            </a>
            <a href="javascript:void(0);" class="btn btn-danger btn-sm btn-icon rounded-circle waves-effect waves-themed"
                data-action="panel-collapse" data-toggle="tooltip" data-offset="0,10" data-original-title="Close">
                <i class="fal fa-times text-white fw-900"></i>
            </a>
        </div>
    </div>
    <div class="panel-container show">
        <div class="panel-content p-0">
            <form [formGroup]="productForm" novalidate class="needs-validation" (ngSubmit)="onSubmit()">
                <div class="panel-content">
                    <div class="form-row">
                        <input type="hidden" id="id" formControlName="id" />
                        <input type="hidden" id="createdOn" formControlName="createdOn"/>
                        <input type="hidden" id="updatedOn" formControlName="updatedOn"/>
                        <input type="hidden" id="unity" formControlName="unity"/>
                        <div class="col-md-6 col-sm-12 mb-3">
                            <label class="form-label" for="name">Nome do pacote <span class="text-danger">*</span> </label>
                            <input type="text" id="name" formControlName="name" class="form-control" placeholder="Nome do pacote" maxlength="100" [ngClass]="{ 'is-invalid': !validProduct && f.name.errors }" required>
                            <div *ngIf="!validProduct && f.name.errors" class="invalid-feedback">
                                <div *ngIf="f.name.errors.required">Por favor, informe o nome do pacote.</div>
                            </div>
                        </div>
                        <div class="col-md-3 col-sm-12 mb-3">
                            <label class="form-label" for="monthlyAmount">Valor mensal <span class="text-danger">*</span> </label>
                            <input class="form-control" currencyMask formControlName="monthlyAmount"
                                [ngClass]="{ 'is-invalid': !validProduct && f.monthlyAmount.errors }" required>
                            <div *ngIf="!validProduct && f.monthlyAmount.errors" class="invalid-feedback">
                                <div *ngIf="f.monthlyAmount.errors.required">Por favor, informe o valor mensal do pacote.</div>
                            </div>
                        </div>
                        <div class="col-md-3 col-sm-12 mb-3">
                            <label class="form-label" for="value">Valor total <span class="text-danger">*</span> </label>
                            <input class="form-control" currencyMask formControlName="value"
                                [ngClass]="{ 'is-invalid': !validProduct && f.value.errors }" required>
                            <div *ngIf="!validProduct && f.value.errors" class="invalid-feedback">
                                <div *ngIf="f.value.errors.required">Por favor, informe o valor total do pacote.</div>
                            </div>
                        </div>
                    </div>
                    <div class="alert alert-warning alert-dismissible text-left fade show mt-3" role="alert" *ngIf="!validProduct">
                        <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                            <span aria-hidden="true"><i class="fal fa-times"></i></span>
                        </button>
                        {{errorMessage}}
                    </div>
                    <div *ngIf="listErrorMessage && !validProduct" class="invalid-feedback">
                        <div *ngFor="let error of listErrorMessage">{{error}}</div>
                    </div>
                    <hr>
                    <div class="row no-gutters">
                        <div class="col-md-12 ml-auto text-right">
                            <div class="btn-group btn-panel">
                                <button id="js-login-btn" class="btn btn-primary" [disabled]="submitted">
                                    <span *ngIf="submitted" class="spinner-border spinner-border-sm mr-1"></span>
                                    Salvar
                                </button>
                                <button id="js-cancel-btn" class="btn btn-default" (click)="onCancel()">Cancelar</button>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    </div>
</div>
